(() => {
  function updateStaffel(fieldset) {
    if (!fieldset) return;

    const radios = Array.from(fieldset.querySelectorAll(".ji-staffel__radio"));
    const checked = radios.find((radio) => radio.checked);
    const index = Math.max(0, radios.indexOf(checked));

    fieldset.querySelectorAll(".ji-staffel__card").forEach((card) => card.classList.remove("is-selected"));

    if (checked) {
      const activeCard = fieldset.querySelector('label[for="' + checked.id + '"]');
      if (activeCard) activeCard.classList.add("is-selected");
    }

    fieldset.querySelectorAll(".ji-snocks-saving").forEach((el) => el.remove());
    fieldset.querySelectorAll(".ji-staffel__marker").forEach((marker) => {
      const tier = Number(marker.dataset.tier || 0) - 1;
      const def = marker.querySelector(".ji-staffel__marker-def");
      const sel = marker.querySelector(".ji-staffel__marker-sel");

      marker.style.display = "none";
      if (def) def.style.display = "none";
      if (sel) sel.style.display = "none";

      if (tier === index && index > 0) {
        marker.style.display = "block";
        if (sel) sel.style.display = "inline";
      } else if (tier > index) {
        marker.style.display = "block";
        if (def) def.style.display = "inline";
      }
    });
  }

  function updateAll() {
    document.querySelectorAll(".ji-staffel").forEach(updateStaffel);
  }

  document.addEventListener("DOMContentLoaded", updateAll);
  document.addEventListener("change", (event) => {
    if (event.target && event.target.matches(".ji-staffel__radio")) updateStaffel(event.target.closest(".ji-staffel"));
  });
  document.addEventListener("click", (event) => {
    const card = event.target.closest(".ji-staffel__card");
    if (card) setTimeout(() => updateStaffel(card.closest(".ji-staffel")), 30);
  });
  document.addEventListener("variant:change", () => setTimeout(updateAll, 40));
  setTimeout(updateAll, 80);
})();

(() => {
  function restoreSocialProofFallback() {
    document.querySelectorAll(".ji-social-proof__text").forEach((element) => {
      const normalized = element.textContent.replace(/\s+/g, " ").trim();

      if (normalized === "Mehr als 503.755 Mal im letzten Jahr gekauft.") {
        element.innerHTML = 'Mehr als <strong class="ji-social-proof__number">503.755</strong> zufriedene Kunden.';
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreSocialProofFallback);
  } else {
    restoreSocialProofFallback();
  }

  document.addEventListener("variant:change", () => window.setTimeout(restoreSocialProofFallback, 40));
})();

(() => {
  const labels = new Map([
    ["200-teilig", "0,10\u20AC/St\u00FCck"],
    ["400-teilig", "0,08\u20AC/St\u00FCck"]
  ]);
  let timers = [];
  let observerStarted = false;

  function selectedLabel(picker) {
    const selectedQty = picker.querySelector(".ji-staffel__card.is-selected .ji-staffel__qty");
    if (selectedQty) return labels.get(selectedQty.textContent.trim()) || null;

    const checked = picker.querySelector(".ji-staffel__radio:checked");
    if (!checked) return null;

    const card = picker.querySelector('label[for="' + checked.id + '"] .ji-staffel__qty');
    return card ? labels.get(card.textContent.trim()) || null : null;
  }

  function upsertUnitPill() {
    const picker = document.querySelector('variant-picker[handle="loetverbinder-200-teilig"]');
    if (!picker) return;

    const label = selectedLabel(picker);
    const priceList = document.querySelector(".product-info__price price-list");
    if (!label || !priceList) return;

    priceList.style.width = "100%";
    priceList.style.maxWidth = "100%";
    priceList.style.boxSizing = "border-box";

    let pill = priceList.querySelector(".ji-unit-pill[data-ji-loetverbinder-unit]");
    if (!pill) pill = priceList.querySelector(".ji-unit-pill");

    if (!pill) {
      pill = document.createElement("unit-price");
      const shippingNotice = priceList.querySelector(".ji-shipping-notice");
      if (shippingNotice) priceList.insertBefore(pill, shippingNotice);
      else priceList.appendChild(pill);
    }

    pill.classList.add("ji-unit-pill");
    pill.dataset.jiLoetverbinderUnit = "true";
    pill.style.cssText = "order:1;margin-left:auto;background:#1f9d4e;color:#fff;border-radius:999px;padding:3px 10px;font-size:12px;font-weight:600;line-height:1.4;display:inline-flex;align-items:center;white-space:nowrap;";
    pill.innerHTML = "nur&nbsp;" + label;
  }

  function scheduleUnitPill() {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers = [60, 250, 800].map((delay) => window.setTimeout(upsertUnitPill, delay));
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;
    new MutationObserver(scheduleUnitPill).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      upsertUnitPill();
      startObserver();
    });
  } else {
    upsertUnitPill();
    startObserver();
  }

  document.addEventListener("change", (event) => {
    if (event.target && event.target.matches(".ji-staffel__radio")) scheduleUnitPill();
  }, true);
  document.addEventListener("click", (event) => {
    if (event.target.closest(".ji-staffel__card")) scheduleUnitPill();
  }, true);
  document.addEventListener("variant:change", scheduleUnitPill);
  setTimeout(upsertUnitPill, 120);
  window.setInterval(upsertUnitPill, 700);
})();

(() => {
  const dayNames = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."];
  let deliveryTimer = null;
  let observerStarted = false;

  function dateKey(date) {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}-${day}`;
  }

  function formatDate(date) {
    return `${dayNames[date.getDay()]} ${date.getDate()}.${date.getMonth() + 1}.`;
  }

  function addDays(date, days) {
    const nextDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    nextDate.setDate(nextDate.getDate() + days);
    return nextDate;
  }

  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  function holidayKeys(year) {
    const fixedHolidays = new Set([
      "01-01",
      "01-06",
      "03-08",
      "05-01",
      "08-15",
      "09-20",
      "10-03",
      "10-31",
      "11-01",
      "12-25",
      "12-26"
    ]);
    const easter = easterSunday(year);

    [
      addDays(easter, -2),
      addDays(easter, 1),
      addDays(easter, 39),
      addDays(easter, 50),
      addDays(easter, 60)
    ].forEach((holiday) => fixedHolidays.add(dateKey(holiday)));

    return fixedHolidays;
  }

  function isBusinessDay(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    return !holidayKeys(date.getFullYear()).has(dateKey(date));
  }

  function addBusinessDays(startDate, days) {
    let result = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let remaining = days;

    while (remaining > 0) {
      result = addDays(result, 1);
      if (isBusinessDay(result)) remaining -= 1;
    }

    return result;
  }

  function deliveryRange() {
    const now = new Date();
    return `${formatDate(addBusinessDays(now, 1))} - ${formatDate(addBusinessDays(now, 3))}`;
  }

  function enhanceDeliveryRows() {
    const range = deliveryRange();

    document.querySelectorAll(".ji-cart-shipping-notice").forEach((row) => {
      const originalText = row.dataset.jiOriginalText || row.textContent || "";
      row.dataset.jiOriginalText = originalText;

      const priceLabel = /ab\s*20/i.test(originalText) ? "ab 20\u20AC kostenlos" : "Kostenlos";
      const key = `${range}|${priceLabel}`;

      if (row.dataset.jiDeliveryEnhanced === key) return;

      row.dataset.jiDeliveryEnhanced = key;
      row.classList.add("ji-cart-delivery-row");
      row.innerHTML = `<span class="ji-cart-delivery-row__date">Lieferung ca. ${range}</span><span class="ji-cart-delivery-row__price">${priceLabel}</span>`;
    });
  }

  function scheduleEnhanceDeliveryRows() {
    window.clearTimeout(deliveryTimer);
    deliveryTimer = window.setTimeout(enhanceDeliveryRows, 40);
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;

    new MutationObserver(scheduleEnhanceDeliveryRows).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      enhanceDeliveryRows();
      startObserver();
    });
  } else {
    enhanceDeliveryRows();
    startObserver();
  }

  document.addEventListener("cart:refresh", scheduleEnhanceDeliveryRows);
  document.addEventListener("cart:change", scheduleEnhanceDeliveryRows);
})();
